
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const strategyData = {
  customer: {
    name: '张明',
    avatar: 'https://public.readdy.ai/ai/img_res/0b1e043549480b3037503c5f318a3861.jpg',
    riskLevel: '平衡型',
    totalAssets: '328万',
  },
  template: '均衡配置策略',
  generatedAt: '2025-01-15 10:28',
  marketView: {
    overall: '震荡向上',
    stocks: { trend: '偏多', confidence: 75 },
    bonds: { trend: '中性', confidence: 60 },
    liquidity: { trend: '适度收紧', confidence: 55 },
  },
  allocation: {
    current: [
      { name: '股票型基金', ratio: 56, amount: '183.7万', color: 'from-red-500 to-orange-500' },
      { name: '债券型基金', ratio: 30, amount: '98.4万', color: 'from-blue-500 to-cyan-500' },
      { name: '货币基金', ratio: 14, amount: '45.9万', color: 'from-green-500 to-teal-500' },
    ],
    suggested: [
      { name: '股票型基金', ratio: 50, amount: '164万', change: -6, color: 'from-red-500 to-orange-500' },
      { name: '债券型基金', ratio: 35, amount: '114.8万', change: +5, color: 'from-blue-500 to-cyan-500' },
      { name: '货币基金', ratio: 15, amount: '49.2万', change: +1, color: 'from-green-500 to-teal-500' },
    ],
  },
  recommendations: [
    {
      type: 'reduce',
      name: '易方达蓝筹精选混合',
      code: '005827',
      currentRatio: 18,
      suggestedRatio: 12,
      amount: '-19.7万',
      reason: '估值偏高，适度减仓锁定收益',
    },
    {
      type: 'add',
      name: '华夏中证500ETF联接',
      code: '001052',
      currentRatio: 8,
      suggestedRatio: 12,
      amount: '+13.1万',
      reason: '中小盘估值修复，增配捕捉机会',
    },
    {
      type: 'add',
      name: '招商产业债券A',
      code: '217022',
      currentRatio: 10,
      suggestedRatio: 15,
      amount: '+16.4万',
      reason: '增配优质债基，平衡组合风险',
    },
    {
      type: 'hold',
      name: '南方中证1000ETF联接',
      code: '004346',
      currentRatio: 10,
      suggestedRatio: 10,
      amount: '0',
      reason: '小盘成长风格，维持当前配置',
    },
  ],
  expectedReturns: {
    optimistic: { rate: '+12.5%', amount: '+41万' },
    neutral: { rate: '+8.2%', amount: '+26.9万' },
    pessimistic: { rate: '+3.8%', amount: '+12.5万' },
  },
  riskMetrics: {
    maxDrawdown: '-8.5%',
    volatility: '11.2%',
    sharpeRatio: '1.65',
    varRisk: '-5.2%',
  },
  aiInsight: '基于张明先生的平衡型风险偏好和当前市场环境，建议适度降低股票仓位，增配债券类资产。当前A股市场估值分化明显，蓝筹股估值偏高，建议减持部分蓝筹基金，增配中小盘指数基金以捕捉估值修复机会。同时，考虑到流动性边际收紧，建议提升债券配置比例至35%，以平衡组合整体风险。',
};

export default function StrategyDetailPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'current' | 'suggested'>('suggested');
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [applied, setApplied] = useState(false);

  const handleApply = () => {
    setApplied(true);
    setTimeout(() => {
      setApplied(false);
    }, 2000);
  };

  const handleShare = (type: string) => {
    setShowShareMenu(false);
  };

  const allocation = activeTab === 'current' ? strategyData.allocation.current : strategyData.allocation.suggested;

  return (
    <div className="min-h-screen bg-gray-50 pb-24">
      {/* 顶部导航 */}
      <div className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md z-50 px-4 py-3 flex items-center justify-between border-b border-gray-100">
        <button onClick={() => navigate(-1)} className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-left-line text-xl text-gray-700"></i>
        </button>
        <span className="text-base font-semibold text-gray-800">配置方案详情</span>
        <button onClick={() => setShowShareMenu(true)} className="w-8 h-8 flex items-center justify-center">
          <i className="ri-share-forward-line text-xl text-gray-700"></i>
        </button>
      </div>

      <div className="pt-16 px-4">
        {/* 客户信息卡片 */}
        <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-2xl p-4 mt-3 text-white">
          <div className="flex items-center gap-3 mb-4">
            <img
              src={strategyData.customer.avatar}
              alt={strategyData.customer.name}
              className="w-12 h-12 rounded-full border-2 border-white/30 object-cover"
            />
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="font-semibold text-lg">{strategyData.customer.name}</span>
                <span className="text-xs bg-white/20 px-2 py-0.5 rounded-full">{strategyData.customer.riskLevel}</span>
              </div>
              <div className="text-sm text-purple-100 mt-0.5">总资产 {strategyData.customer.totalAssets}</div>
            </div>
            <div className="text-right">
              <div className="text-xs text-purple-200">策略模板</div>
              <div className="text-sm font-medium">{strategyData.template}</div>
            </div>
          </div>
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-1.5 text-purple-100">
              <i className="ri-magic-line"></i>
              <span>AI智能生成</span>
            </div>
            <div className="flex items-center gap-1.5 text-purple-100">
              <i className="ri-time-line"></i>
              <span>{strategyData.generatedAt}</span>
            </div>
          </div>
        </div>

        {/* 市场观点 */}
        <div className="bg-white rounded-2xl p-4 mt-4 shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 flex items-center justify-center bg-blue-50 rounded-lg">
              <i className="ri-line-chart-line text-blue-600"></i>
            </div>
            <span className="font-semibold text-gray-800">市场观点</span>
            <span className="ml-auto text-xs text-green-600 bg-green-50 px-2 py-0.5 rounded-full">
              {strategyData.marketView.overall}
            </span>
          </div>
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-600 w-16">A股市场</span>
              <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-green-400 to-green-500 rounded-full"
                  style={{ width: `${strategyData.marketView.stocks.confidence}%` }}
                ></div>
              </div>
              <span className="text-sm font-medium text-green-600 w-12 text-right">{strategyData.marketView.stocks.trend}</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-600 w-16">债券市场</span>
              <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-blue-400 to-blue-500 rounded-full"
                  style={{ width: `${strategyData.marketView.bonds.confidence}%` }}
                ></div>
              </div>
              <span className="text-sm font-medium text-blue-600 w-12 text-right">{strategyData.marketView.bonds.trend}</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-600 w-16">流动性</span>
              <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-orange-400 to-orange-500 rounded-full"
                  style={{ width: `${strategyData.marketView.liquidity.confidence}%` }}
                ></div>
              </div>
              <span className="text-sm font-medium text-orange-600 w-12 text-right">{strategyData.marketView.liquidity.trend}</span>
            </div>
          </div>
        </div>

        {/* 资产配置对比 */}
        <div className="bg-white rounded-2xl p-4 mt-4 shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 flex items-center justify-center bg-purple-50 rounded-lg">
              <i className="ri-pie-chart-2-line text-purple-600"></i>
            </div>
            <span className="font-semibold text-gray-800">资产配置</span>
          </div>
          
          {/* Tab切换 */}
          <div className="flex bg-gray-100 rounded-full p-1 mb-4">
            <button
              onClick={() => setActiveTab('current')}
              className={`flex-1 py-2 rounded-full text-sm font-medium transition-all ${
                activeTab === 'current' ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-500'
              }`}
            >
              当前配置
            </button>
            <button
              onClick={() => setActiveTab('suggested')}
              className={`flex-1 py-2 rounded-full text-sm font-medium transition-all ${
                activeTab === 'suggested' ? 'bg-white text-purple-600 shadow-sm' : 'text-gray-500'
              }`}
            >
              建议配置
            </button>
          </div>

          {/* 配置比例条 */}
          <div className="h-4 bg-gray-100 rounded-full overflow-hidden flex mb-4">
            {allocation.map((item, index) => (
              <div
                key={index}
                className={`bg-gradient-to-r ${item.color}`}
                style={{ width: `${item.ratio}%` }}
              ></div>
            ))}
          </div>

          {/* 配置详情 */}
          <div className="space-y-3">
            {allocation.map((item, index) => (
              <div key={index} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className={`w-3 h-3 bg-gradient-to-r ${item.color} rounded-full`}></div>
                  <span className="text-sm text-gray-700">{item.name}</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-sm text-gray-500">{item.amount}</span>
                  <span className="text-sm font-bold text-gray-800 w-10 text-right">{item.ratio}%</span>
                  {activeTab === 'suggested' && 'change' in item && (
                    <span className={`text-xs font-medium w-10 text-right ${
                      (item as any).change > 0 ? 'text-red-500' : (item as any).change < 0 ? 'text-green-500' : 'text-gray-400'
                    }`}>
                      {(item as any).change > 0 ? '+' : ''}{(item as any).change}%
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 调仓建议 */}
        <div className="bg-white rounded-2xl p-4 mt-4 shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 flex items-center justify-center bg-green-50 rounded-lg">
              <i className="ri-exchange-funds-line text-green-600"></i>
            </div>
            <span className="font-semibold text-gray-800">调仓建议</span>
          </div>
          <div className="space-y-3">
            {strategyData.recommendations.map((item, index) => (
              <div key={index} className="p-3 bg-gray-50 rounded-xl">
                <div className="flex items-start gap-3">
                  <div className={`w-8 h-8 flex items-center justify-center rounded-lg ${
                    item.type === 'add' ? 'bg-red-50' : item.type === 'reduce' ? 'bg-green-50' : 'bg-gray-100'
                  }`}>
                    <i className={`${
                      item.type === 'add' ? 'ri-add-line text-red-500' : 
                      item.type === 'reduce' ? 'ri-subtract-line text-green-500' : 
                      'ri-checkbox-circle-line text-gray-400'
                    }`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-sm font-medium text-gray-800 truncate">{item.name}</span>
                      <span className={`text-sm font-bold ${
                        item.type === 'add' ? 'text-red-500' : item.type === 'reduce' ? 'text-green-500' : 'text-gray-400'
                      }`}>
                        {item.amount}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs text-gray-400">{item.code}</span>
                      <span className="text-xs text-gray-400">|</span>
                      <span className="text-xs text-gray-500">{item.currentRatio}% → {item.suggestedRatio}%</span>
                    </div>
                    <p className="text-xs text-gray-500 bg-white px-2 py-1 rounded">{item.reason}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 预期收益 */}
        <div className="bg-white rounded-2xl p-4 mt-4 shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 flex items-center justify-center bg-yellow-50 rounded-lg">
              <i className="ri-funds-line text-yellow-600"></i>
            </div>
            <span className="font-semibold text-gray-800">预期收益测算</span>
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div className="text-center p-3 bg-gradient-to-br from-green-50 to-teal-50 rounded-xl">
              <div className="text-xs text-gray-500 mb-1">乐观情景</div>
              <div className="text-lg font-bold text-green-600">{strategyData.expectedReturns.optimistic.rate}</div>
              <div className="text-xs text-green-500">{strategyData.expectedReturns.optimistic.amount}</div>
            </div>
            <div className="text-center p-3 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl">
              <div className="text-xs text-gray-500 mb-1">中性情景</div>
              <div className="text-lg font-bold text-blue-600">{strategyData.expectedReturns.neutral.rate}</div>
              <div className="text-xs text-blue-500">{strategyData.expectedReturns.neutral.amount}</div>
            </div>
            <div className="text-center p-3 bg-gradient-to-br from-orange-50 to-red-50 rounded-xl">
              <div className="text-xs text-gray-500 mb-1">悲观情景</div>
              <div className="text-lg font-bold text-orange-600">{strategyData.expectedReturns.pessimistic.rate}</div>
              <div className="text-xs text-orange-500">{strategyData.expectedReturns.pessimistic.amount}</div>
            </div>
          </div>
        </div>

        {/* 风险指标 */}
        <div className="bg-white rounded-2xl p-4 mt-4 shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 flex items-center justify-center bg-red-50 rounded-lg">
              <i className="ri-shield-check-line text-red-600"></i>
            </div>
            <span className="font-semibold text-gray-800">风险指标</span>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-gray-50 rounded-xl p-3">
              <div className="text-xs text-gray-500 mb-1">最大回撤</div>
              <div className="text-base font-bold text-red-600">{strategyData.riskMetrics.maxDrawdown}</div>
            </div>
            <div className="bg-gray-50 rounded-xl p-3">
              <div className="text-xs text-gray-500 mb-1">波动率</div>
              <div className="text-base font-bold text-orange-600">{strategyData.riskMetrics.volatility}</div>
            </div>
            <div className="bg-gray-50 rounded-xl p-3">
              <div className="text-xs text-gray-500 mb-1">夏普比率</div>
              <div className="text-base font-bold text-green-600">{strategyData.riskMetrics.sharpeRatio}</div>
            </div>
            <div className="bg-gray-50 rounded-xl p-3">
              <div className="text-xs text-gray-500 mb-1">VaR风险</div>
              <div className="text-base font-bold text-blue-600">{strategyData.riskMetrics.varRisk}</div>
            </div>
          </div>
        </div>

        {/* AI洞察 */}
        <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-4 mt-4 border border-purple-100">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-7 h-7 flex items-center justify-center bg-purple-100 rounded-lg">
              <i className="ri-robot-line text-purple-600"></i>
            </div>
            <span className="font-semibold text-gray-800">AI 策略解读</span>
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">{strategyData.aiInsight}</p>
        </div>
      </div>

      {/* 底部操作栏 */}
      <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-gray-100 px-4 py-3 flex gap-3">
        <button
          onClick={() => setShowShareMenu(true)}
          className="flex-1 h-11 bg-gray-100 rounded-xl flex items-center justify-center gap-2 text-gray-700"
        >
          <i className="ri-send-plane-line"></i>
          <span className="text-sm font-medium">发送客户</span>
        </button>
        <button
          onClick={handleApply}
          className="flex-1 h-11 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl flex items-center justify-center gap-2 text-white"
        >
          <i className={`${applied ? 'ri-check-line' : 'ri-check-double-line'}`}></i>
          <span className="text-sm font-medium">{applied ? '已应用' : '应用方案'}</span>
        </button>
      </div>

      {/* 分享菜单 */}
      {showShareMenu && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-end" onClick={() => setShowShareMenu(false)}>
          <div className="w-full bg-white rounded-t-3xl p-4 pb-8" onClick={(e) => e.stopPropagation()}>
            <div className="w-10 h-1 bg-gray-200 rounded-full mx-auto mb-4"></div>
            <h3 className="text-base font-semibold text-gray-800 text-center mb-4">发送方案给客户</h3>
            <div className="grid grid-cols-4 gap-4">
              <button onClick={() => handleShare('wechat')} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center bg-green-500 rounded-xl">
                  <i className="ri-wechat-fill text-2xl text-white"></i>
                </div>
                <span className="text-xs text-gray-600">微信</span>
              </button>
              <button onClick={() => handleShare('enterprise')} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-500 rounded-xl">
                  <i className="ri-building-line text-2xl text-white"></i>
                </div>
                <span className="text-xs text-gray-600">企业微信</span>
              </button>
              <button onClick={() => handleShare('sms')} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-xl">
                  <i className="ri-message-2-fill text-2xl text-white"></i>
                </div>
                <span className="text-xs text-gray-600">短信</span>
              </button>
              <button onClick={() => handleShare('email')} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-500 rounded-xl">
                  <i className="ri-mail-fill text-2xl text-white"></i>
                </div>
                <span className="text-xs text-gray-600">邮件</span>
              </button>
            </div>
            <button
              onClick={() => setShowShareMenu(false)}
              className="w-full h-11 bg-gray-100 rounded-xl mt-6 text-gray-600 font-medium"
            >
              取消
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
